import Modal from '../../mini/Modal'
import React, { useState } from 'react'
import { ModalStyles } from './styled'
import { H5, P2, P3, Input, ErrorTypography } from '../../styled/typography/typography'
import Button from '../../mini/Button'
import Password from '../../mini/Password'
import { LinkGuardianAccount } from './API'
import { hideModal, showModal } from '../../../actions/_modal'
import { useDispatch } from 'react-redux'

const LinkGuardianModal = ({ response, token  }) => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState()
  const [credentialError, setCredentialError] = useState(false)
  const [emailErrors, setEmailErrors] = useState(false)
  const [password, setPassword] = useState('')
  const [linkingAccount, setLinkingAccount] = useState(false)

  const onGoBack = () => {
    dispatch(hideModal())
    dispatch(showModal('CREATE_GUARDIAN_ACCOUNT', { response, token }))
  }

  const validateEmail = (email) => {
    const regEx = /\S+@\S+\.\S+/
    return regEx.test(email)
  }

  const handleEmailBlur = () => {
    if (validateEmail(email)) {
      setEmailErrors(false)
    } else {
      setEmailErrors(true)
    }
  }

  const handleEmailChange = e => {
    setEmail(e.target.value)
  }

  const linkGuardian = async (email, password, token) => {
    setLinkingAccount(true)
    const res = await LinkGuardianAccount(email, password, token)

    if (res.error === 'user_not_found') { // credentials error
      setCredentialError(true)
      setLinkingAccount(false)

    } else if (res.error === 'user_not_a_guardian') { // attempting to link non-guardian OE account
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_EMAIL_IN_USE', { response, token }))

    } else if (res.error === 'email_token_not_valid') { // attempting to link non-guardian OE account
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_ACCOUNT_ERROR', { response, token }))

    } else if (res instanceof Error) { // generic error
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_ACCOUNT_ERROR', { response, token }))

    } else if (!res.error) { // success
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_ACCOUNT_SUCCESS', { linked: true, email: email, password: password }))

    } else { // catch all
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_ACCOUNT_ERROR', { response, token }))
    }
  }

  const shouldButtonBeDisabled = () => {
    const errors = [(!email || !password), emailErrors, linkingAccount]
    return errors.includes(true)
  }

  return (
    <Modal
      width={473}
      topPx={410}
      autoHeight
      background={'transparent'}
      opacity={'1'}
      boxShadow={'0 0 30px 0 rgba(0,0,0,0.07)'}
    >
      <ModalStyles>
        <div className="center">
          <H5 style={{ marginBottom: '20px' }}>
            Provide the following to link your existing account to { response.student_name }...
          </H5>
          {credentialError &&
            <ErrorTypography className="status-text">
              Oops! Your username or password was incorrect.
            </ErrorTypography>
          }
        </div>
        <P2 className="input-label">Email</P2>
        <Input
          type="email"
          placeholder="Email"
          onChange={(e) => handleEmailChange(e)}
          onBlur={handleEmailBlur}
        />
        {emailErrors &&
          <P2 className="error">Please enter a valid email address.</P2>
        }
        <P2 className="input-label">Password</P2>
        <Password
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <Button
          text="Link Account"
          style={{ margin: '32px auto' }}
          className={`quest-btn btn-a go uncap ${
            shouldButtonBeDisabled() ? 'disabled' : 'active'}
             ${linkingAccount && 'no-animate'}`}
          onClick={
            !shouldButtonBeDisabled()
              ? () => linkGuardian(email, password, token)
              : null
          }/>
        <div className="center">
          <P3 className="link" onClick={onGoBack}>
            Go Back
          </P3>
        </div>
      </ModalStyles>
    </Modal>
  )
}

export default LinkGuardianModal
